/**
 * HTTP fetcher for older activity past the local PowerSync retention window.
 */
import { api } from "@/lib/api";
import { type ActivityHistoryPage, mapApiActivityRow } from "@fleet/plugins/activity";

export async function fetchOlderActivity(
  before: string | null,
  limit: number,
): Promise<ActivityHistoryPage | null> {
  const { data, error } = await api.GET("/api/activity", {
    params: { query: { before: before ?? undefined, limit } },
  });
  if (error || !data) {
    return null;
  }
  return {
    rows: (data.items ?? []).map(mapApiActivityRow),
    hasMore: Boolean(data.nextBefore),
  };
}
